/** @format */

import { Box, Divider, IconButton, MenuItem, MenuList, Popover } from '@mui/material';
import React, { memo, useState } from 'react';
import createStyle from './styles';
import { TextCus } from 'components/TextCus';
import { userOptionsData } from 'utils';
import { IActionUserOpts } from 'types/actions';
import { fontSize } from 'theme';
import useMode from 'hooks/useMode';
import { Icons } from 'assets';
import { useAuthentication } from 'hooks';
import ModalSettings from './ModalSettings';

const UserOptions = ({ isOpen, onClose }) => {
  const mode = useMode();
  const [state, setState] = useState<any>({})
  const { resetStore } = useAuthentication()
  const onLogout = () => {
    resetStore()
    handleClose();
  }
  const styles = createStyle();


  //setting
  const handleAction = (action: IActionUserOpts) => async (value?: unknown) => {
    switch (action) {
      case 'logout':
        return onLogout();
      case 'setting':
        handleClose();
        return setState(oldS => ({ ...oldS, isShowSetting: !oldS.isShowSetting }));
      default:
        break;
    }
  };
  const handleClose = () => {
    onClose?.();
  };

  return (
    <>
      <Popover open={!!isOpen} onClose={handleClose} anchorEl={isOpen} sx={{ top: 45 }}>
        <Box display={'flex'} justifyContent={'center'} my={3} alignItems={'center'}>
          <IconButton>{Icons.User(mode.primary)}</IconButton>
          <TextCus
            color={mode.primary}
            fontWeight={600}
            fontSize={fontSize.sm}
          >
            Administrator
          </TextCus>
        </Box>
        <Divider />
        <MenuList sx={[styles.container, styles.bgWhite]}>
          {userOptionsData?.map(item => {
            return (
              <MenuItem key={`${item.id}`} onClick={handleAction(item.key as IActionUserOpts)}>
                <Box
                  sx={[styles.row, styles.btn]}

                >
                  <IconButton>{item?.icon}</IconButton>
                  <TextCus useI18n={item.useI18n}>{item?.title}</TextCus>
                </Box>
                {/* Menu change language */}
              </MenuItem>
            );
          })}
        </MenuList>
      </Popover>
      {state.isShowSetting && (
        <ModalSettings open={state.isShowSetting} onClose={handleAction('setting')} />
      )}
    </>
  );
};
export default memo(UserOptions);
